import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getTranslations, getProject } from '@lib/api';
import ValutazioneHeader from 'components/valutazione/ValutazioneHeader';
import ProjectHeader from '@components/project/ProjectHeader';
import {
  ValutazioneGeneral,
  ValutazioneESGNEW,
  // ValutazioneSROI,
  ValutazioneSROINEW,
  ValutazioneSROIAUD,
} from '@components/valutazione';
import { getPercentageSROI, getPercentageESG } from '@lib/api/index';
import { MonitoringLinkBanner } from '@components/monitoring';
import MonitoringHeader from 'components/monitoring/MonitoringHeader';
import MonitoringButtonToolbar from 'components/monitoring/MonitoringButtonToolbar';
// import ValutazioneSROINEW from 'components/valutazione/ValutazioneSROINEW';

const Valutazione = (props) => {
  const [project, setProject] = useState(null);
  const { projectId = null, versionId = null } = useParams();
  const [translations, setTranslations] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [vanBenefits, setVanBenefits] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [, setTutorialFinalButtonVisible] = useState(null);

  const activeStep =
    props.location.pathname.indexOf('esg') > 1
      ? 'esg'
      : props.location.pathname.indexOf('sroi') > 1
        ? 'sroi'
        : 'general';

  useEffect(() => {
    getTranslations().then((retrievedTranslation) => {
      setTranslations(retrievedTranslation);
    });

    if (projectId) {
      getProject(projectId, versionId).then((retrievedProject) => {
        let tempQuestions = [...retrievedProject.questions];
        tempQuestions = tempQuestions.map((el) => ({
          ...el,
          dependsOnAnswers: el.dependsOnAnswers
            ? el.dependsOnAnswers.split(',').map((el) => Number(el))
            : [],
        }));
        retrievedProject.questions = tempQuestions;

        setProject(retrievedProject);
        setVanBenefits(
          retrievedProject.sroiratings
            .filter((el) => el.code === 'VANBENEFITS')
            .map((el) => Number(el.value))
            .pop(),
        );
      });
    } else {
      setProject({});
    }
  }, [projectId, versionId]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const obj = { esg: 0, sroi: 0 };
  //     if (project?.proponentCode === 'ET' || project?.interventionClassCode === 'NOINTPURCH') {
  //       obj.sroi = 100;
  //     } else {
  //       //TODO: Add versionId argument to the getPercentageSROI call
  //       // const percentageSROI = await getPercentageSROI(projectId, versionId);
  //       const percentageSROI = await getPercentageSROI(projectId);
  //       obj.sroi = percentageSROI?.percentage;
  //     }
  //     //TODO: Add versionId argument to the getPercentageESG call
  //     // const percentageESG = await getPercentageESG(projectId, versionId);
  //     const percentageESG = await getPercentageESG(projectId);
  //     obj.esg = percentageESG;
  //     setTutorialFinalButtonVisible(Object.values(obj).every((value) => value === 100));
  //   };
  //   if ((projectId || isUpdated) && project) {
  //     fetchData();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [projectId, isUpdated, project, versionId]);
  const isInMonitoring = props.location.pathname.indexOf('monitoraggio') > -1;
  if (!project) return null;

  return (
    <>
      <div id='valutazione' className='scenari megaContent'>
        <div className='container-fluid'>
          <ProjectHeader project={project} translations={translations} />
          {/* TODO Need to change the logic below once BE is ready with the correct property*/}
          {project?.id && !!project?.isMonitoring && !isInMonitoring && (
            <MonitoringLinkBanner projectId={projectId} versionId={project?.ver && project.ver} />
          )}
          {/* TODO Need to change the logic below once BE is ready with the correct property*/}
          {isInMonitoring && (
            <MonitoringButtonToolbar
              projectId={projectId}
              versionId={versionId ? parseInt(versionId) : null}
              projectLastVersion={project?.ver}
            />
          )}
          {!isInMonitoring ? (
            <ValutazioneHeader
              activeStep={activeStep}
              projectId={parseInt(projectId)}
              projectStatus={project.status}
              sectorCode={project.sectorCode}
              interventionClassCode={project.interventionClassCode}
              // financingTypeCode={project.financingTypeCode}
              proponentCode={project.proponentCode}
              vanBenefits={vanBenefits}
              translations={translations}
              isUpdated={isUpdated}
              setIsUpdated={setIsUpdated}
              clientId={project.clientId}
              requestId={project.requestId}
              updatedAt={project.updatedAt}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          ) : (
            <MonitoringHeader
              activeStep={activeStep}
              projectId={parseInt(projectId)}
              projectStatus={project.status}
              sectorCode={project.sectorCode}
              interventionClassCode={project.interventionClassCode}
              // financingTypeCode={project.financingTypeCode}
              proponentCode={project.proponentCode}
              vanBenefits={vanBenefits}
              translations={translations}
              isUpdated={isUpdated}
              setIsUpdated={setIsUpdated}
              clientId={project.clientId}
              requestId={project.requestId}
              updatedAt={project.updatedAt}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isMonitoring={!!project?.isMonitoring}
              isInMonitoring={isInMonitoring}
              monitoringVersion={versionId}
              projectMonitoringVersion={project?.ver}
            />
          )}

          {activeStep === 'general' && (
            <ValutazioneGeneral
              currentProject={project}
              translations={translations}
              isMonitoring={!!project?.isMonitoring}
              isInMonitoring={isInMonitoring}
              monitoringVersion={versionId}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          )}
          {activeStep === 'esg' && (
            <ValutazioneESGNEW
              currentProject={project}
              translations={translations}
              isMonitoring={!!project.isMonitoring}
              isInMonitoring={isInMonitoring}
              monitoringVersion={versionId}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          )}
          {activeStep === 'sroi' && project.proponentCode === 'AUD' && (
            <ValutazioneSROIAUD
              currentProject={project}
              translations={translations}
              isUpdated={isUpdated}
              setIsUpdated={setIsUpdated}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isMonitoring={!!project?.isMonitoring}
              isInMonitoring={isInMonitoring}
              monitoringVersion={versionId}
              isyes={true}
            />
          )}
          {activeStep === 'sroi' && project.proponentCode !== 'AUD' && (
            <ValutazioneSROINEW
              currentProject={project}
              translations={translations}
              isMonitoring={!!project?.isMonitoring}
              isInMonitoring={isInMonitoring}
              monitoringVersion={versionId}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default Valutazione;
